<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel modal__panel--termination">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--potential"></div>
      <div class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form form--terminate">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">
              {{ $t(`addPotentialPolicyModal.${"title"}`) }}
            </div>
          </div>
        </div>

        <div v-if="teamId == null" class="add__form add__form--terminate">
          <transition name="fade" mode="out-in">
            <Loading v-if="isModalLoading" />
            <div v-else class="add__content">
              <div class="termination">
                <div class="termination__row">
                  <div class="termination__column"> 
                    <div class="form__field">
                      <VSelect class="select select--default" :placeholder="$t(`addPotentialPolicyModal.${'teams'}`)"
                        :class="{ 'select--error': teamIdHasError }" :options="fetchedTeams" :reduce="(team) => team.id"
                        :getOptionLabel="(team) => `${team.name}`" v-model="teamId"
                        @update:modelValue="fetchPolicyData(teamId)" />
                      <div class="form__error" v-if="teamIdHasError">
                        {{ $t(`addPotentialPolicyModal.${'teamsMsg'}`) }}
                      </div>
                    </div>
                    <div class="form__field disabled-el">
                      <VSelect disabled class="select select--default" :placeholder="$t(`addPotentialPolicyModal.${'customer'}`)" />
                    </div>
                    <div class="form__field disabled-el">
                      <VSelect disabled class="select select--default"
                        :placeholder="$t(`addPotentialPolicyModal.${'agentDropdown'}`)" />
                    </div>
                    <div class="form__field disabled-el">
                      <Datepicker disabled class="input input--default" :config="statics.datePickerConfig"
                        :placeholder="$t(`addPotentialPolicyModal.${'dateDropdown'}`)" v-model="date" />
                    </div>
                  </div>
                  <div class="termination__column termination__column--middle">
                    <div class="form__field disabled-el">
                      <VSelect disabled class="select select--default"
                        :placeholder="$t(`addPotentialPolicyModal.${'categoryDropdown'}`)" />
                    </div>
                    <div class="form__field disabled-el">
                      <VSelect disabled class="select select--default"
                        :placeholder="$t(`addPotentialPolicyModal.${'priorityDropdown'}`)" />
                    </div>
                    <div class="form__field disabled-el">
                      <textarea disabled placeholder="Text" cols="30" rows="10"
                        class="input--default termination__textarea"></textarea>
                    </div>
                  </div>
                  <div class="termination__column">
                    <DropFile :disabled="true" @input="files = $event" />
                  </div> 
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div v-else class="add__form add__form--terminate">
          <transition name="fade" mode="out-in">
            <Loading v-if="isModalLoading" />
            <div v-else class="add__content">
              <div class="termination">
                <div class="termination__row">
                  <div class="termination__column">
                    <div class="form__field">
                      <div class="input input--default input--readonly">
                        {{ customerDetails.team ? customerDetails.team.name : 'Loading...' }}
                      </div>
                    </div>
                    <div class="form__field">
                      <VSelect v-if="customerMembers.length" class="select select--default" :options="customerMembers"
                        :reduce="(member) => member.id" :getOptionLabel="(member) => parseCustomerName(member)"
                        v-model="customerId" />
                      <div v-else class="input input--default input--readonly">
                        {{ customerDetails && customerDetails.id ? parseCustomerName(customerDetails) : '...' }}
                      </div>
                    </div>
                    <div class="form__field">
                      <VSelect class="select select--default" :class="{ 'select--error': agentHasError }"
                        :options="agents" :reduce="(agent) => agent.id"
                        :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                        :placeholder="$t(`addPotentialPolicyModal.${'agentDropdown'}`)" v-model="agentId" />
                      <div class="form__error" v-if="agentHasError">
                        {{ $t(`addPotentialPolicyModal.${"agentErrorMsg"}`) }}
                      </div>
                    </div>
                    <div class="form__field">
                      <Datepicker class="input input--default" :class="{ 'input--error': dateHasError }"
                        :config="statics.datePickerConfig"
                        :placeholder="$t(`addPotentialPolicyModal.${'dateDropdown'}`)" v-model="date" />
                      <div class="form__error" v-if="dateHasError">
                        {{ $t(`addPotentialPolicyModal.${"dateErrorMsg"}`) }}
                      </div>
                    </div>
                  </div>
                  <div class="termination__column termination__column--middle">
                    <div class="form__field">
                      <VSelect class="select select--default" :class="{ 'select--error': categoryHasError }"
                        :options="categories" :reduce="(category) => category.id" :label="`long_${language}`"
                        :placeholder="$t(`addPotentialPolicyModal.${'categoryDropdown'}`)" v-model="branchCategoryId" />
                      <div class="form__error" v-if="categoryHasError">
                        {{ $t(`addPotentialPolicyModal.${"categoryErrorMsg"}`) }}
                      </div>
                    </div>
                    <div class="form__field">
                      <VSelect class="select select--default" :options="priorities" :reduce="(priority) => priority.id"
                        label="type" :placeholder="$t(`addPotentialPolicyModal.${'priorityDropdown'}`)"
                        v-model="priorityId" />
                    </div>
                    <div class="form__field">
                      <textarea placeholder="Text" cols="30" rows="10"
                        class="input input--default termination__textarea" v-model="text"></textarea>
                    </div>
                  </div>
                  <div class="termination__column">
                    <DropFile @input="files = $event" />
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else>
        <div v-if="teamId == null" class="disabled-el">
          <button class="modal__button modal__button--submit button button--default">
            <span>{{ $t(`addPotentialPolicyModal.${"saveButton"}`) }}</span>
          </button>
        </div>
        <div v-else>
          <button class="modal__button modal__button--submit button button--default" @click="createPotentialPolicy()">
            <span>{{ $t(`addPotentialPolicyModal.${"saveButton"}`) }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import DropFile from "@/components/DropFile";
import Loading from "@/partials/Loading";
import { parseCustomerName } from "@/helpers/entityParsers";
import statics from "@/statics";
import { useI18n } from 'vue-i18n';   

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();
defineOptions({
  name: "AddPotentialPolicyModal"
});

const store = useStore();
const route = useRoute();
const { proxy } = getCurrentInstance();

// Primitive Reactive State Properties
const teamIdHasError = ref(false);
const teamId = ref(null);
const formLoading = ref(true);
const isRequesting = ref(false);

const policyId = ref("");
const customerId = ref("");
const agentId = ref("");
const branchCategoryId = ref("");
const text = ref("");
const date = ref("");
const priorityId = ref("");
const files = ref([]);

const agentHasError = ref(false);
const dateHasError = ref(false);
const categoryHasError = ref(false);

// Computed Mapping Streams (Replaces options maps from mapGetters)
const customerDetails = computed(() => store.getters.customerDetails);
const potentialPolicyForms = computed(() => store.getters.potentialPolicyForms);
const customerMembers = computed(() => store.getters.customerMembers);
const potentialPolicyToEdit = computed(() => store.getters.potentialPolicyToEdit);
const language = computed(() => store.getters.language);
const userForms = computed(() => store.getters.userForms);
const potentialPolicyModalLoading = computed(() => store.getters.potentialPolicyModalLoading);

const isModalLoading = computed(() => formLoading.value || potentialPolicyModalLoading.value);
const fetchedTeams = computed(() => userForms.value?.teams || []);
const agents = computed(() => potentialPolicyForms.value?.agents || []);
const categories = computed(() => potentialPolicyForms.value?.categories || []);
const priorities = computed(() => potentialPolicyForms.value?.priorities || []);

// Watch Logic Handlers
watch(agentId, (value) => {
  agentHasError.value = !value;
});

watch(date, (value) => {
  dateHasError.value = !value;
});

watch(branchCategoryId, (value) => {
  categoryHasError.value = !value;
});

watch(customerDetails, async () => {
  await hydrateFromCustomerDetails();
}, { deep: true });


// Method Context Declarations
const fetchPolicyData = async (id) => {
  store.commit("setAgents", null);
  customerId.value = customerDetails.value?.id || "";

  if (Object.keys(potentialPolicyToEdit.value || {}).length) {
    await store.dispatch("getPotentialPolicyForms", id);
    agentId.value = null;
  } else {
    await store.dispatch("getPotentialPolicyForms", id);
  }
};

const closeModal = () => {
  store.commit("setShowAddPotentialPolicyModal", false);
  store.commit("setPotentialPolicyToEdit", {});
  store.commit("setPotentialPolicyModalLoading", false);
};

const hydrateFromCustomerDetails = async () => {
  if (!customerDetails.value?.id || !customerDetails.value?.team?.id) {
    return;
  }

  if (Object.keys(potentialPolicyToEdit.value || {}).length && teamId.value) {
    return;
  }

  const customerTeamId = Number(customerDetails.value.team.id);
  if (teamId.value === customerTeamId) {
    return;
  }

  customerId.value = Number(customerDetails.value.id);
  teamId.value = customerTeamId;

  const shouldHandleLoading = !formLoading.value;
  if (shouldHandleLoading) {
    formLoading.value = true;
  }

  try {
    await fetchPolicyData(teamId.value);
  } finally {
    if (shouldHandleLoading) {
      formLoading.value = false;
    }
  }
};

const goBack = () => {
  closeModal();
  store.commit("setShowAddCustomerServicesModal", true);
};

const buildPotentialCustomersPayloadFromQuery = () => {
  const q = route.query || {};

  return {
    search: q.search || "",
    page: Number(q.page) || 1,
    teams: q.teams ? q.teams.split(",").map(Number) : [],
    agents: q.agents ? q.agents.split(",").map(Number) : [],
    branchCategories: q.branchCategories ? q.branchCategories.split(",").map(Number) : [],
    companyTypes: q.companyTypes ? q.companyTypes.split(",").map(Number) : [],
    priorities: q.priorities ? q.priorities.split(",").map(Number) : [],
    startDateFrom: q.startDateFrom || "",
    startDateTo: q.startDateTo || "",
    endDateFrom: q.endDateFrom || "",
    endDateTo: q.endDateTo || "",
    zip_from: q.zip_from || "",
    zip_to: q.zip_to || "",
    birthday: q.birthday || "",
  };
};

const refreshPotentialCustomersTable = async () => {
  if (route.name !== "PotentialCustomers") {
    return;
  }

  try {
    const payload = buildPotentialCustomersPayloadFromQuery();
    await store.dispatch("searchPotentialCustomers", payload);
  } catch (error) {
    console.error("Potential customers refresh failed:", error.response?.data || error);
  }
};

const shouldRefreshGlobalCustomer = () => {
  return route.name !== "PotentialCustomers";
};

const loadFormsToEdit = async () => {
  const p = potentialPolicyToEdit.value;
  if (!p) return;

  if (p.team_id) {
    await store.dispatch("getPotentialPolicyForms", p.team_id);
    teamId.value = p.team_id;
  }

  policyId.value = p.id;
  customerId.value = p.customer_id;
  text.value = p.text;
  date.value = p.date;

  agentId.value = p.agent?.id || null;
  branchCategoryId.value = p.category?.id || null;
  priorityId.value = p.priority?.id || null;
};

const validateFields = (callback) => {
  agentHasError.value = !agentId.value;
  dateHasError.value = !date.value;
  categoryHasError.value = !branchCategoryId.value;

  if (!agentHasError.value && !dateHasError.value && !categoryHasError.value) {
    callback(true);
  } else {
    callback(false);
  }
};

const createPotentialPolicy = async () => {
  isRequesting.value = true;
  const currentCustomerId = customerId.value || customerDetails.value?.id;

  validateFields(async (state) => {
    if (state) {
      let id = null;
      try {
        if (Object.keys(potentialPolicyToEdit.value || {}).length) {
          const response = await store.dispatch("updatePotentialPolicy", {
            policyId: policyId.value,
            customer_id: currentCustomerId,
            agent_id: agentId.value,
            branch_category_id: branchCategoryId.value,
            text: text.value,
            date: date.value,
            priority_id: priorityId.value,
            team_id: teamId.value
          });

          id = response.data?.data?.id || response.data?.id || policyId.value;

          store.commit("setToast", {
            display: true,
            type: "success",
            message: t("messages.potentialPolicyUpdatedSuccessfully"),
          });

        } else {
          const { data } = await store.dispatch("createPotentialPolicy", {
            customerId: currentCustomerId,
            agentId: agentId.value,
            date: date.value,
            branchCategoryId: branchCategoryId.value,
            priorityId: priorityId.value,
            text: text.value,
            teamId: teamId.value
          });
          id = data.data?.id || data.id;

          if (route.path == '/dashboard') {
            try {
              await store.dispatch("getSalesDashboard");
            } catch (error) {
              console.error("Policy Error:", error.response?.data || error);
            }
          }

          store.commit("setToast", {
            display: true,
            type: "success",
            message: t("messages.potentialPolicyCreatedSuccessfully"),
          });
        }
      } catch (err) {
        console.error("Policy Error:", err.response?.data || err);
        isRequesting.value = false;
        return;
      }

      if (files.value.length && id) {
        const filePayload = files.value.map((file) => file.file);
        await store.dispatch("addPotentialPolicyFile", {
          potentialPolicyId: id,
          files: filePayload,
        });
      }

      await refreshPotentialCustomersTable();

      if (shouldRefreshGlobalCustomer()) {
        await store.dispatch("getGlobalCustomer", currentCustomerId);
      }
      closeModal();
    } else {
      isRequesting.value = false;
    }
  });
};

// Lifecycle Hooks Execution Blocks
onMounted(async () => {
  formLoading.value = true;

  if (!(proxy.$checkRolePermission('potential_policy_create') || proxy.$checkRolePermission('potential_policy_edit'))) {
    closeModal();
    return;
  }

  try {
    if (!userForms.value || !userForms.value.teams) {
      await store.dispatch("getUserForms");
    }

    if (Object.keys(potentialPolicyToEdit.value || {}).length) {
      await loadFormsToEdit();
    } else if (customerDetails.value?.id) {
      await hydrateFromCustomerDetails();
    }
  } catch (error) {
    console.error("Initialization error", error);
  } finally {
    formLoading.value = false;
  }
});

onBeforeUnmount(() => {
  closeModal();
});
</script>
<style scoped lang="scss">
@use "../assets/scss/termination-potential-policy";
 
.termination__row {
  border: 0;
  display: flex;
}

.add__content {
  margin-top: 0px !important;
}

.termination {
  padding-top: 0px;
}
</style>
